module.exports = __webpack_public_path__ + "img/logo-taipei-city@2x.b5c8a4c3.png";